import { useState as v, useEffect as a } from "react";
import { findActivePath as c } from "../components/mobile-navigation/roche-mobile-navigation-helpers.js";
function x(t, n) {
  const [r, s] = v([t]);
  return a(() => {
    if (!n) return;
    const f = c(t.nestedLinks || [], n);
    if (!f) return;
    const u = f.reduce(
      (e, d) => {
        var o;
        const i = e[e.length - 1], h = (o = i == null ? void 0 : i.nestedLinks) == null ? void 0 : o[d];
        return h ? [...e, h] : e;
      },
      [t]
    );
    s(u);
  }, [t, n]), [r, s];
}
export {
  x as useActiveNavigationPath
};
